export enum SortDirection {
    ASC,
    DESC,
    DEFAULT,
}
